import { Component } from '@angular/core';
import { SvgIconComponent } from '../../../../components/svg-icons/svg-icon.component';
import { FlatButtonDirective } from '../../../directives/flat-button/flat-button.directive';

@Component({
  selector: 'app-helpbar',
  imports: [SvgIconComponent, FlatButtonDirective],
  templateUrl: './helpbar.component.html',
  styleUrl: './helpbar.component.scss',
})
export class HelpbarComponent {}
